/**
 * Resolves the active session user for socket connection.
 *
 * userDetails Recoil is only set during login and is empty after a page refresh,
 * even though MemoryType.USER and MemoryType.TOKEN remain in localStorage.
 */
import { useMemo } from "react";
import { useRecoilValue } from "recoil";
import { userDetails } from "../components/recoil/userDataRecoil";
import LocalStorageHandler from "../service/memory/handler/LocalStorageHandler";
import MemoryType from "../service/memory/enum/MemoryType";

const localStorage = new LocalStorageHandler();

const readStoredUser = () => {
  const user = localStorage.read(MemoryType.USER);
  const token = localStorage.read(MemoryType.TOKEN);

  if (!user?.userIdentifier || typeof token !== "string" || !token.trim()) {
    return null;
  }

  return user;
};

export const useAuthenticatedSession = () => {
  const recoilUser = useRecoilValue(userDetails);

  return useMemo(() => {
    if (recoilUser?.userIdentifier) {
      return recoilUser;
    }

    return readStoredUser();
  }, [recoilUser]);
};

export const isSessionActive = (user) =>
  Boolean(user?.userIdentifier && user?.organizationIdentifier);
